import {
  Component,
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { AsyncPipe } from '@angular/common';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
// Ag-Grid
import {
  GridOptions,
  GridApi,
  ColDef,
  RowSelectionOptions,
  CellContextMenuEvent,
} from 'ag-grid-community';
import { agGridDarkTheme } from 'src/app/shared/components/ag-grid/dark-theme';
import { Subscription } from 'rxjs';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
// models
import { FirearmManagementColumnDef } from './columnDefs';
import { Firearm } from 'src/app/shared/models/general';
import {
  Answers,
  ComponentNames,
  ModalID,
  ModalType,
  Questions,
  Statements,
  StatusModalIndicator,
} from 'src/app/shared/models/constants';
//components
import { DispoEditBtnsComponent } from '../../shared/components/ag-grid/dispo-edit-btns/dispo-edit-btns.component';
import { FirearmManagementEditComponent } from './modals/firearm-management-edit/firearm-management-edit.component';
// Services
import { SharedService } from '../../shared/services/shared.service';
import { AgGridService } from 'src/app/shared/services/ag-grid.service';
import { ContextMenuService } from '../../shared/services/context-menu.service';
import { isObjectEmpty } from 'src/app/shared/functions';

@Component({
  selector: 'app-firearm-management',
  templateUrl: './firearm-management.component.html',
  styleUrls: ['./firearm-management.component.scss'],
  standalone: true,
  imports: [AgGridAngular, AsyncPipe, BsDropdownModule],
})
export class FirearmManagementComponent implements OnDestroy {
  subscriptions = new Subscription();
  rowData: Firearm[] = [];
  selected_row: Firearm;
  @ViewChild('grid', { read: ElementRef }) gridElement!: ElementRef;
  @ViewChild('grid') grid!: AgGridAngular;
  menuState$ = this.contextMenuService.menuState$;

  public rowSelection: RowSelectionOptions = {
    mode: 'singleRow',
    enableSelectionWithoutKeys: true,
    checkboxes: false,
  };
  // ag-grid properties Grid
  gridApi!: GridApi;

  columnDefs: ColDef[] = FirearmManagementColumnDef;
  defaultColDef;
  detailCellRendererParams: any;
  overlayLoadingTemplate;
  overlayNoRowsTemplate;
  gridOptions: GridOptions = {
    theme: agGridDarkTheme,
    suppressDragLeaveHidesColumns: true,
  };
  components: any;
  theme = agGridDarkTheme;

  modalRef: BsModalRef;
  modalConfig = {
    animated: true,
  };

  constructor(
    private router: Router,
    public sharedService: SharedService,
    private modalService: BsModalService,
    private agGridService: AgGridService,
    private contextMenuService: ContextMenuService,
    private cdr: ChangeDetectorRef,
  ) {
    this.overlayLoadingTemplate =
      '<span style="padding: 10px; border: 2px solid #444;background: #2399e5; color: white;"><i class="fa fa-spinner fa-spin"></i> Finding Disposition Records...</span>';
    this.overlayNoRowsTemplate =
      '<span style="padding: 10px; border: 2px solid #444;background: #2399e5; color: white;"><i class="fa fa-spinner fa-spin"></i> No Records Found!</span>';
    this.gridOptions = <GridOptions>{};
    this.gridOptions.headerHeight = 50;
    this.gridOptions.rowHeight = 25;
    this.gridOptions.enableCellTextSelection = true; // Allows text selection for copying
    this.gridOptions.ensureDomOrder = true; // Ensures proper DOM order for accessibility
    this.gridOptions.suppressClipboardPaste = false; // Allow clipboard operations
    this.gridOptions.context = { ConfigComponent: this }; // this allows access to component functions
    this.gridOptions.rowClass = 'ag-grid-row';
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      floatingFilter: true,
      wrapHeaderText: true,
    };
    this.rowSelection = {
      mode: 'singleRow',
      enableSelectionWithoutKeys: true,
      checkboxes: false,
    };
    this.components = {
      editDeleteBtns: DispoEditBtnsComponent,
    };
    // firearm list retrieved
    this.subscriptions.add(
      this.sharedService.firearm_list_retrieved$.subscribe((response) => {
        // this.rowData = this.sharedService.firearm_list;
      }),
    );
    // yes / no submit
    this.subscriptions.add(
      this.sharedService.yes_no_submit$.subscribe((response) => {
        if (
          response['answer'] === Answers.yes &&
          response['question'] === Questions.delete_this_firearm
        ) {
          this.sharedService.deleteFirearm(
            response['optional_details'] as Firearm,
          );
        }
      }),
    );
    // firearm to add
    this.subscriptions.add(
      this.sharedService.firearm_to_add$.subscribe((firearm) => {
        if (firearm.modal_type === ModalType.add) {
          this.addFirearm(firearm.form_values);
        } else {
          this.editFirearm(firearm.form_values);
        }
      }),
    );
    // firearm list updated
    this.subscriptions.add(
      this.sharedService.firearm_list_updated$.subscribe((firearm_list) => {
        this.rowData = firearm_list;
        this.sharedService.raiseSuccessToast(
          Statements.firearm_successfully_added,
        );
      }),
    );
  }

  async onGridReady(params: any) {
    this.gridApi = params.api;

    if (!this.agGridService.hasCachedSettingsFor(ComponentNames.firearm_management)) {
      await this.agGridService.loadSavedTableSettings(
        ComponentNames.firearm_management,
      );
    }
    this.applyCurrentSessionPreferences();
  }

  ngAfterViewInit() {
    this.contextMenuService.initialize(this.cdr, this.gridElement);
  }
  ngOnInit(): void {
    this.addButtonColumn();
    if (this.sharedService.firearm_list.length > 0) {
      this.rowData = [];
      this.rowData = this.sharedService.firearm_list;
    } else {
      this.refreshTableDataClick();
    }
  }
  addButtonColumn() {
    const hasEditDelete = this.columnDefs.some(
      (column) => column.headerName === 'Edit / Delete',
    );
    if (!hasEditDelete) {
      this.columnDefs.push({
        // Edit / Delete
        headerName: 'Edit / Delete',
        field: 'edit_delete',
        resizable: true,
        width: 140,
        minWidth: 140,
        pinned: 'right',
        suppressMovable: true,
        cellRenderer: 'editDeleteBtns',
        cellRendererParams: {
          editFirearm: this.editFirearmClicked.bind(this),
          deleteFirearm: this.deleteFirearmClicked.bind(this),
        },
      });
    }
  }
  async addFirearm(new_firearm: Firearm) {
    await this.sharedService.addFirearmToAvailabilityList(new_firearm);
  }
  async editFirearm(firearm_to_edit: Firearm) {
    await this.sharedService.editFirearm(firearm_to_edit);
  }

  // button click functions
  editFirearmClicked(selected_row: { colValues: Firearm; rowIndex: number }) {
    this.addEditFirearmClick(ModalType.edit, selected_row['colValues']);
  }
  deleteFirearmClicked(selected_row: { colValues: Firearm; rowIndex: number }) {
    this.sharedService.openYesNoModal(
      Questions.delete_this_firearm,
      selected_row['colValues'],
    );
  }
  async refreshTableDataClick() {
    this.sharedService.openStatusSpinner('Loading');
    await this.sharedService.getFirearmList();
    this.sharedService.closeStatusSpinner();
  }
  addEditFirearmClick(modal_type: string, row_data?: Firearm) {
    const modalOptions: ModalOptions = {
      initialState: {
        modal_type: modal_type,
        selected_row: modal_type === ModalType.edit ? row_data : null,
      } as any,
      ignoreBackdropClick: true,
      // backdrop: 'static',
      keyboard: false,
      class: 'modal-dialog, modal-dialog-centered, modal-lg',
    };
    this.modalRef = this.modalService.show(
      FirearmManagementEditComponent,
      Object.assign({ id: ModalID.firearm_management_edit }, modalOptions),
    );
  }

  openHome() {
    this.router.navigate(['home']);
  }

  // right click copy functions
  onCellContextMenu(event: CellContextMenuEvent) {
    this.contextMenuService.onCellContextMenu(event);
  }
  onMenuMouseEnter() {
    this.contextMenuService.onMenuMouseEnter();
  }
  onMenuMouseLeave() {
    this.contextMenuService.onMenuMouseLeave();
  }
  copyCellValue() {
    this.contextMenuService.copyCellValue();
  }

  // preference functions
  storeCurrentSessionFilters() {
    this.agGridService.storeCurrentSessionFilters(
      ComponentNames.firearm_management,
      this.gridApi.getFilterModel(),
    );
  }
  storeCurrentSessionColumnConfig() {
    this.agGridService.storeCurrentSessionColumnConfig(
      ComponentNames.firearm_management,
      this.gridApi?.getColumnState(),
    );
  }
  applyCurrentSessionPreferences() {
    let component: any = this.agGridService.current_session_filtering.find(
      (component) =>
        component.component_name === ComponentNames.firearm_management,
    );
    if (component && !isObjectEmpty(component.filters)) {
      this.gridApi.setFilterModel(component.filters);
    }
    component = this.agGridService.current_session_column_config.find(
      (component) =>
        component.component_name === ComponentNames.firearm_management,
    );
    if (component && !isObjectEmpty(component.column_config)) {
      this.gridApi?.applyColumnState({
        state: component.column_config,
        applyOrder: true,
      });
    }
  }
  saveCurrentTablePreferencesClick() {
    const filters = this.gridApi.getFilterModel();
    const column_state = this.gridApi?.getColumnState();
    this.agGridService.saveCurrentTableSettings(
      ComponentNames.firearm_management,
      filters,
      column_state,
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
